import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model for data handling
import { devConfig } from 'config/config'; // Importing development configuration settings

/**
 * Class representing the tableQuotaRetractionReportAgentView.
 * Extends the JetView class to create a specific view for quota retraction reports.
 */
export default class tableQuotaRetractionReportAgentView extends JetView {
    /**
     * Defines the configuration for the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and the translation function
        const _ = this.app.getService('locale')._;
        // Define the date format based on the application configuration
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Get the current user parameter from the request
        const cur_user = this.getParam('user', true);
        return {
            rows: [
                {
                    cols: [
                        {
                            view: 'datatable', // Define a datatable view
                            id: 'datatable', // Set the ID for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // Apply CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: screen.width < 820 ? false : true, // Enable vertical scrolling based on screen width
                            height: screen.width < 820 ? 405 : 0, // Set height based on screen width
                            columns: [
                                {
                                    id: 'ActionTittle', // Column ID for action title
                                    header: '', // Column header
                                    width: 65, // Column width
                                    height: 25, // Column height
                                    tooltip: _('Acción'), // Tooltip for the column
                                    template: function (obj) {
                                        // Template function to render cell content
                                        if (obj.StateId !== 'P') {
                                            // Check if the state is not 'Pending'
                                            return '';
                                        } else {
                                            if (
                                                devConfig.getPermAction(
                                                    'approvalQuotaRetraction',
                                                    'Approve', // Check if the user has permission to approve
                                                )
                                            ) {
                                                // Return icons for approval and refusal actions
                                                return "<span class='webix_icon wxi-close approve prm-approvalQuotaRetraction'></span><span class='webix_icon wxi-close torefuse prm-approvalQuotaRetraction'></span>";
                                            } else {
                                                return '';
                                            }
                                        }
                                    },
                                },
                                {
                                    id: 'Id', // Column ID for the record ID
                                    header: 'Id', // Column header
                                    width: 90, // Column width
                                    sort: 'int', // Enable integer sorting
                                },
                                {
                                    id: 'Date', // Column ID for creation date
                                    header: _('Fecha Creación'), // Column header with localization
                                    fillspace: 0, // Disable fillspace
                                    minWidth: 0, // Minimum width
                                    width: 200, // Column width
                                    sort: 'text', // Enable text sorting
                                    format: dateFormat, // Format the date using the defined date format
                                },
                                {
                                    id: 'UserCreate', // Column ID for user who created the record
                                    header: _('Usuario Creó'), // Column header with localization
                                    width: 200, // Column width
                                    sort: 'int', // Enable integer sorting
                                },
                                {
                                    id: 'Amount', // Column ID for amount
                                    header: _('Valor'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Enable integer sorting
                                    format: webix.Number.numToStr({
                                        // Format the number with specific settings
                                        groupDelimiter: ',',
                                        groupSize: 3,
                                        decimalDelimiter: '.',
                                        decimalSize: 2,
                                    }),
                                },
                                {
                                    id: 'StateId', // Column ID for state
                                    header: _('Estado'), // Column header with localization
                                    editor: 'combo', // Enable combo editor for this column
                                    options: [
                                        // Define options for the combo editor
                                        { id: 'A', value: _('Aprobada') }, // Approved
                                        { id: 'R', value: _('Rechazada') }, // Rejected
                                        { id: 'P', value: _('Pendiente') }, // Pending
                                    ],
                                    width: 110, // Column width
                                    sort: 'int', // Enable integer sorting
                                },
                            ],
                            onClick: {
                                torefuse: function (euv, id) {
                                    // Click event for refusal action
                                    var vvthis = this; // Reference to the current context
                                    webix.confirm({
                                        // Show confirmation dialog
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea Rechazar la Retracción de Saldo?'), // Warning message
                                        ok: _('Rechazar Retracción de Saldo'), // OK button text
                                        cancel: _('Salir'), // Cancel button text
                                        callback: function (action) {
                                            // Callback for confirmation action
                                            if (action === true) {
                                                // If confirmed
                                                var item = vvthis.getItem(id); // Get the item from the datatable
                                                webix
                                                    .ajax() // Perform an AJAX request
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Agent/ApprovalQuotaRetraction', // API endpoint
                                                        '{"Id":"' + item.Id + '", "State":"R"}', // Request payload
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                // Error callback
                                                                webix.message(
                                                                    _('Error! '), // Show error message
                                                                );
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                // Success callback
                                                                var json = JSON.parse(
                                                                    text, // Parse the response
                                                                );
                                                                if (
                                                                    json.HasError // Check for errors in the response
                                                                ) {
                                                                    webix.message({
                                                                        title: _('¡Error!'),
                                                                        type: 'alert-error',
                                                                        text: _(
                                                                            'Ocurrio un error, comuniquese con soporte',
                                                                        ), // Error message
                                                                    });
                                                                } else {
                                                                    webix.message({
                                                                        text: _(
                                                                            'Estado de Retracción actualizado', // Success message
                                                                        ),
                                                                        title: _('¡Exito!'),
                                                                        type: 'alert-warning',
                                                                    });
                                                                    item.StateId = 'R'; // Update the state to 'Rejected'
                                                                    $$('datatable').refresh(); // Refresh the datatable
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                                approve: function (euv, id) {
                                    // Click event for approval action
                                    var vvthis = this; // Reference to the current context
                                    webix.confirm({
                                        // Show confirmation dialog
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea Aprobar el Retracción de Saldo?'), // Warning message
                                        ok: _('Aprobar Retracción de Saldo'), // OK button text
                                        cancel: _('Salir'), // Cancel button text
                                        callback: function (action) {
                                            // Callback for confirmation action
                                            if (action === true) {
                                                // If confirmed
                                                var item = vvthis.getItem(id); // Get the item from the datatable
                                                webix
                                                    .ajax() // Perform an AJAX request
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Agent/ApprovalQuotaRetraction', // API endpoint
                                                        '{"Id":"' + item.Id + '", "State":"A"}', // Request payload
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                // Error callback
                                                                webix.message(
                                                                    _('Error! '), // Show error message
                                                                );
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                // Success callback
                                                                console.log(
                                                                    text, // Log the response
                                                                );
                                                                var json = JSON.parse(
                                                                    text, // Parse the response
                                                                );
                                                                if (
                                                                    json.HasError // Check for errors in the response
                                                                ) {
                                                                    webix.message({
                                                                        title: _('¡Error!'),
                                                                        type: 'alert-error',
                                                                        text: _(
                                                                            'Ocurrio un error, comuniquese con soporte', // Error message
                                                                        ),
                                                                    });
                                                                } else {
                                                                    webix.message({
                                                                        text: _(
                                                                            'Estado de Retracción actualizado', // Success message
                                                                        ),
                                                                        title: _('¡Exito!'),
                                                                        type: 'alert-warning',
                                                                    });
                                                                    item.StateId = 'A'; // Update the state to 'Approved'
                                                                    $$('datatable').refresh(); // Refresh the datatable
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                            },
                            on: {
                                onItemDblClick: function () {
                                    // Double-click event on an item
                                    $$('editwin').show(); // Show the edit window
                                },
                            },
                            ready: function () {
                                // Event triggered when the datatable is ready
                                if (!this.count()) {
                                    // Check if there are no items
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        // Show overlay message
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') + // No data message
                                            '</div>',
                                    );
                                }
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable mathematical operations
                            loadahead: 0, // Set load ahead parameter
                            datafetch: devConfig.getDefaultDataFetch(), // Set default data fetch
                            pager: 'pagerA', // Set the pager ID
                        },
                    ],
                },
            ],
        }; // Placeholder for the configuration content
    }

    /**
     * Initializes the view after the configuration is set.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        // Initialize the grid component for the datatable
        grid = $$('datatable');

        // Retrieve the current user parameter from the application context
        const cur_user = this.getParam('user', true);

        // Construct the base URL for the API call to get quota retraction data
        var url = devConfig.geturlApi() + 'null/Report/GetQuotaRetraction?FromId=' + cur_user + '&';

        // Initialize an empty string for the filter parameters
        var filter = '';

        // Set up an event listener for the 'transfers:filter' event
        this.on(this.app, 'transfers:filter', (filterData) => {
            // Convert filterData object into an array of entries
            var object = Object.entries(filterData);
            var string1 = '';

            // Iterate through each filter entry
            for (var i = 0; i < object.length; i++) {
                // Check if the filter value is not an object and not empty
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle date range selection
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        // Handle single date selection
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        } else {
                            // Format the date for the filter
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', '');
                                string1 = string1 + '&dateFrom=' + date;
                                string1 = string1 + '&dateTo=' + date;
                            }
                        }
                    }
                } else {
                    // Handle object type filter values
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]);
                        // Iterate through the nested filter object
                        for (var j = 0; j < object2.length; j++) {
                            // Check if the value is not null
                            if (object2[j][1] !== null) {
                                // Handle start date
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    // Handle end date
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            // Append the current user ID to the filter string
            string1 = string1 + '&FromId=' + cur_user;

            // Clear the grid data before loading new data
            grid.clearAll();
            // Load the data into the grid with the constructed URL and filter parameters
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            // Update the filter variable with the current filter string
            filter = string1;
        });

        // Attach an event listener for sorting the grid data
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Reload the grid data with sorting parameters
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir);
        });

        // Attach an event listener for data requests
        grid.attachEvent('onDataRequest', function (start, count) {
            // Call the custom load function to fetch data
            custom_load(this.data.url, start, count);
            return true;
        });

        // Function to load data into the grid with pagination
        function custom_load(url, start, count) {
            // Load the data into the grid with start and count parameters
            grid.load(url + '?start=' + start + '&count=' + count);
        }

        // Set up an event listener for player selection
        this.on(this.app, 'player:select', (id) => {
            // Load the grid data filtered by the selected player ID
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + id);
        }); // Placeholder for the initialization content
    }
}

// FILE DOCUMENTED
